const EVENT_PREFIX = 'psychedelic:homepage_';

function publishHomepageEvent(name, detail = {}) {
  const payload = {
    page_path: window.location.pathname,
    ...detail,
  };
  const eventName = `${EVENT_PREFIX}${name}`;

  try {
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(eventName, payload);
    }
  } catch (error) {
    console.warn('[Homepage analytics] Shopify event failed', error);
  }

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event: eventName.replace(':', '_'),
      ...payload,
    });
  }

  window.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
}

class HeadlineRotator extends HTMLElement {
  connectedCallback() {
    this.headline = this.querySelector('[data-headline]');
    this.headlines = JSON.parse(this.dataset.headlines || '[]').filter(Boolean);
    this.mode = this.dataset.mode || 'rotate';
    this.interval = Math.max(Number(this.dataset.interval) || 5, 3) * 1000;
    this.index = 0;
    this.viewed = new Set();
    this.isVisible = false;

    if (!this.headline || this.headlines.length < 1) return;

    const queryIndex = Number(new URLSearchParams(window.location.search).get('pw_headline'));
    if (Number.isInteger(queryIndex) && queryIndex >= 1 && queryIndex <= this.headlines.length) {
      this.index = queryIndex - 1;
    } else if (this.mode === 'session') {
      const savedIndex = Number(sessionStorage.getItem('pw_homepage_headline'));
      this.index = Number.isInteger(savedIndex) && savedIndex < this.headlines.length
        ? savedIndex
        : Math.floor(Math.random() * this.headlines.length);
      sessionStorage.setItem('pw_homepage_headline', String(this.index));
    }

    this.render(false);

    this.observer = new IntersectionObserver(([entry]) => {
      this.isVisible = entry.isIntersecting;
      if (this.isVisible) {
        this.recordView();
        this.start();
      } else {
        this.stop();
      }
    }, { threshold: 0.5 });
    this.observer.observe(this);

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
  }

  disconnectedCallback() {
    this.stop();
    this.observer?.disconnect();
  }

  start() {
    if (
      this.mode !== 'rotate'
      || this.timer
      || !this.isVisible
      || this.headlines.length < 2
      || window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) return;

    this.timer = window.setInterval(() => {
      this.index = (this.index + 1) % this.headlines.length;
      this.render(true);
    }, this.interval);
  }

  stop() {
    window.clearInterval(this.timer);
    this.timer = null;
  }

  render(animate) {
    const update = () => {
      this.headline.textContent = this.headlines[this.index];
      this.dataset.activeIndex = String(this.index + 1);
      this.dataset.activeHeadline = this.headlines[this.index];
      this.classList.remove('is-changing');
      this.recordView();
    };

    if (!animate) {
      update();
      return;
    }

    this.classList.add('is-changing');
    window.setTimeout(update, 180);
  }

  recordView() {
    if (!this.isVisible || this.viewed.has(this.index)) return;
    this.viewed.add(this.index);
    publishHomepageEvent('headline_viewed', {
      headline_index: this.index + 1,
      headline_text: this.headlines[this.index],
      rotation_mode: this.mode,
    });
  }
}

if (!customElements.get('headline-rotator')) {
  customElements.define('headline-rotator', HeadlineRotator);
}

function activeHeadline() {
  const rotator = document.querySelector('headline-rotator');
  return {
    headline_index: Number(rotator?.dataset.activeIndex || 0),
    headline_text: rotator?.dataset.activeHeadline || '',
  };
}

document.addEventListener('toggle', (event) => {
  const faq = event.target.closest('[data-pw-homepage-faq]');
  if (!faq?.open) return;

  publishHomepageEvent('faq_opened', {
    faq_index: Number(faq.dataset.faqIndex || 0),
    question: faq.querySelector('summary')?.textContent?.trim() || '',
  });
}, true);

document.addEventListener('click', (event) => {
  const link = event.target.closest('a');
  if (!link || !document.querySelector('main[data-template="index"]')) return;

  const trackedCta = link.closest('[data-pw-cta-id]');
  if (trackedCta) {
    publishHomepageEvent('cta_clicked', {
      cta_id: trackedCta.dataset.pwCtaId,
      cta_text: link.textContent.trim(),
      destination: link.pathname,
      ...activeHeadline(),
    });
    return;
  }

  const productCard = link.closest('.resource-list__item');
  if (productCard) {
    const cards = [...productCard.parentElement.children];
    publishHomepageEvent('product_clicked', {
      product_position: cards.indexOf(productCard) + 1,
      product_handle: link.pathname.split('/products/')[1]?.split(/[?#/]/)[0] || '',
      destination: link.pathname,
      ...activeHeadline(),
    });
    return;
  }

  const hero = link.closest('[id*="hero_aB8hKR"]');
  if (hero && link.pathname.includes('/products/good-mood-mix-strawberry-kiwi')) {
    publishHomepageEvent('cta_clicked', {
      cta_id: 'hero_strawberry_kiwi',
      cta_text: link.textContent.trim(),
      destination: link.pathname,
      ...activeHeadline(),
    });
    return;
  }

  if (link.pathname === '/pages/build-you-own-bundle') {
    publishHomepageEvent('cta_clicked', {
      cta_id: 'build_your_mix',
      cta_text: link.textContent.trim(),
      destination: link.pathname,
      ...activeHeadline(),
    });
  }
});
